import { render, staticRenderFns } from "./copy-url-clipboard.vue?vue&type=template&id=1dfa5b4a"
import script from "./copy-url-clipboard.vue?vue&type=script&lang=js"
export * from "./copy-url-clipboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports